export default "__VITE_ASSET___VoDO$Vh__"